import React, { useEffect, useState } from "react";
import NavHeader from "../components/nav/NavHeader";
import SideMenu from "../components/nav/Sidemenu";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Analytics from "../components/analytics";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import Login from "./Login";
import { getToken } from "../components/auth/authConfig";
import UserManagement from "../components/userAdmin/UserManagement";
import UserRegistration from "../components/userAdmin/UserRegistrationTab";
import AddFaqs from "../components/pageLayouts/AddFaqs";
import TabStrip from "../components/layout/TabStrip";
import PageHeader from "../components/layout/PageHeader";
import AccessDenied from "../components/layout/AccessDenied";
import { useUserAssignedPages } from "../context/UserAssignedPagesContext";
import { FaUserShield, FaUserPlus, FaQuestionCircle, FaChartBar } from "react-icons/fa";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box sx={{ p: 0 }}><Typography component="div">{children}</Typography></Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

const UserAdministration = () => {
  const [Tabvalue, setTabValue] = useState(() => {
    // Initialize from URL hash if present
    const hash = window.location.hash.slice(1).toLowerCase();
    const tabMap = { "access-management": 0, "user-registration": 1, "faqs": 2, "analytics": 3 };
    return tabMap[hash] ?? 0;
  });
  const [passtoken, setPasstoken] = useState(null);
  const { features: featureFlags, ensureLoaded } = useUserAssignedPages();

  const allTabs = [
    {
      TabHeader: "Access Management",
      icon: <FaUserShield />,
      title: "Access Management",
      subtitle: "View, search and manage existing platform users",
      render: () => <UserManagement passtoken={passtoken} />,
    },
    {
      TabHeader: "User Registration",
      icon: <FaUserPlus />,
      title: "User Registration",
      subtitle: "Register new users and assign their roles and permissions",
      render: () => <UserRegistration />,
    },
    {
      TabHeader: "FAQs",
      icon: <FaQuestionCircle />,
      title: "FAQs",
      subtitle: "Create and manage frequently asked questions for users",
      render: () => <AddFaqs />,
      requiresFeature: "FAQs",
    },
    {
      TabHeader: "Analytics",
      icon: <FaChartBar />,
      title: "Analytics",
      subtitle: "Review platform usage and engagement analytics",
      render: () => <Analytics />,
      requiresFeature: "Analytics",
    },
  ];

  // Hide the FAQs / Analytics tabs unless the user's Tool Roles enable that feature
  const tabHeader = allTabs.filter((tab) => !tab.requiresFeature || featureFlags[tab.requiresFeature]);

  // Update URL hash when tab changes
  const handleTabChange = (newValue) => {
    const tab = tabHeader[newValue];
    if (tab) {
      const hash = tab.TabHeader.toLowerCase().replace(/\s+/g, "-");
      window.history.replaceState(null, "", `#${hash}`);
    }
    setTabValue(newValue);
  };

  // Sync tab from hash on mount (for visible tabs only)
  useEffect(() => {
    const hash = window.location.hash.slice(1).toLowerCase();
    if (hash) {
      const idx = tabHeader.findIndex(
        (t) => t.TabHeader.toLowerCase().replace(/\s+/g, "-") === hash
      );
      if (idx !== -1 && idx !== Tabvalue) {
        setTabValue(idx);
      }
    }
  }, [tabHeader.length]); // Re-run when available tabs change

  useEffect(() => {
    ensureLoaded().catch(() => {});
  }, [ensureLoaded]);

  // Keep the active tab in range if the tab list shrinks (e.g. a feature got disabled)
  useEffect(() => {
    if (Tabvalue >= tabHeader.length) {
      setTabValue(0);
    }
  }, [tabHeader.length, Tabvalue]);

  useEffect(() => {
    const initToken = async () => {
      const token = await getToken();
      setPasstoken(token);
    };
    initToken();
  }, []);


  return (
    <div>
      <AuthenticatedTemplate>
        <div id="AdminPage">
          <NavHeader />
          <SideMenu />
          {true ? (
            <>
              <div style={{ position: "relative" }} id="main">
                <PageHeader
                  title={tabHeader[Tabvalue]?.title || "User Administration"}
                  subtitle={tabHeader[Tabvalue]?.subtitle || "Manage users, registrations, FAQs and platform analytics"}
                />
                <Box sx={{ width: "100%" }}>
                  <TabStrip
                    tabs={tabHeader.map(t => ({ label: t.TabHeader, icon: t.icon }))}
                    active={Tabvalue}
                    onChange={handleTabChange}
                  />

                  {tabHeader.map((tab, index) => (
                    <CustomTabPanel key={tab.TabHeader} className={`TabPannel${index || ""}`} value={Tabvalue} index={index}>
                      {tab.render()}
                    </CustomTabPanel>
                  ))}
                </Box>
              </div>
            </>
          ) : (
            <div id="main">
              <AccessDenied />
            </div>
          )}

        </div>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </div>
  );
};

export default UserAdministration;
